import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const ThreeD = createIcon({
  displayName: 'ThreeD',
  viewBox: '0 0 32 32',
  path: [
    <svg fill="currentColor" key="threeD">
      <path
        clipRule="evenodd"
        d="M3.9998 6.39995H27.9998V25.6H3.99981L3.9998 6.39995ZM0.799805 6.39995C0.799805 4.63264 2.23249 3.19995 3.9998 3.19995H27.9998C29.7671 3.19995 31.1998 4.63264 31.1998 6.39995V25.6C31.1998 27.3673 29.7671 28.8 27.9998 28.8H3.99981C2.23249 28.8 0.799805 27.3673 0.799805 25.6V6.39995ZM21.8969 11.7989L16.6969 9.71889C16.5062 9.6426 16.2934 9.6426 16.1027 9.71889L10.9027 11.7989C10.599 11.9204 10.3998 12.2145 10.3998 12.5417V19.4584C10.3998 19.7855 10.599 20.0797 10.9027 20.2012L16.1027 22.2812C16.2934 22.3575 16.5062 22.3575 16.6969 22.2812L21.8969 20.2012C22.2006 20.0797 22.3998 19.7855 22.3998 19.4584V12.5417C22.3998 12.2145 22.2006 11.9204 21.8969 11.7989ZM15.9998 19.2L12.7998 18V13.6L15.9998 14.8V19.2Z"
        fillRule="evenodd"
      />
    </svg>,
  ],
})
